import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { tokens } from "@/locales/translations/tokens";
import { Star } from "lucide-react";
import { useTranslation } from "react-i18next";

interface RelevanceValueProps {
  value: number;
  className?: string;
}
export default function RelevanceValue(props: RelevanceValueProps) {
  const { t } = useTranslation();
  return (
    <Badge variant="secondary" className={cn("transition-all flex gap-x-1 items-center", props.className)}>
      {t(tokens.workstation.sources.relevance)}: {props.value}%
      {props.value >= 95 && <Star color="black" fill="#ffc800" strokeWidth={1} size={14} /> }
    </Badge>
  )
}